import { BaseOption, useSelect } from 'admin';
import { ApiMaterialsV1MaterialGradesRetrieveIncludedItems, MaterialGradeInfoNested } from 'api';

import { AutocompleteField, AutocompleteFieldProps, AutocompleteOption } from '../AutocompleteField/AutocompleteField';

const compareLabelsDescending = (a: BaseOption, b: BaseOption) => b.label.localeCompare(a.label);

export type MaterialGradeAutocompleteProps = Omit<AutocompleteFieldProps<AutocompleteOption>, 'options'> & {
  includedItems?: ApiMaterialsV1MaterialGradesRetrieveIncludedItems;
};

export const MaterialGradeAutocomplete = (props: MaterialGradeAutocompleteProps) => {
  const { includedItems = 'all', ...rest } = props;
  const { options: materialGradeOptions } = useSelect<MaterialGradeInfoNested>({
    dataProviderName: 'materials',
    filters: [
      {
        field: 'included_items',
        operator: 'eq',
        value: includedItems,
      },
    ],
    optionLabel: 'name',
    optionValue: 'id',
    resource: `/v1/material-grades/`,
  });

  return (
    <AutocompleteField<AutocompleteOption>
      data-testid="material-grade-autocomplete"
      options={materialGradeOptions.sort(compareLabelsDescending)}
      {...rest}
    />
  );
};
